import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Timeout por defecto: evita que una petición "colgada" (p.ej. el balanceador de producción
// retiene/corta la conexión) quede pendiente para siempre y deje la Terminal en loading eterno.
// Al vencer, axios rechaza con ECONNABORTED (sin `response`) => isNetworkError()=true => se activa
// el manejo offline/error existente y se libera el estado de carga.
const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Fase 0 — `formatApiError` (puro) se movió a @/domain/apiError; se re-exporta para compatibilidad.
export { formatApiError } from "@/domain/apiError";

export default api;
